module.exports = "/assets/data/d090e327d0c439b02d725c8e9c9c24f7-G75.data.json";